import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/industries/companion-diagnostics-services")({
  head: () => buildRouteHead("/en/industries/companion-diagnostics-services", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/industries/companion-diagnostics", replace: true });
  },
});
